import React, {Component} from 'react';
import {reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {login} from '../../actions/Index';
import {Loader} from "../Common/Loader";
import About from "../Common/About";

class RegistrationSuccess extends Component {

    constructor(props) {
        super(props);
        this.state = {
            toggleModal     : false,
            modalType       : '',
            username        : '',
            accessToken     : '',
            tokenType       : '',
            showLoader      : false
        };
    }
    
    /**
     * Close modal
     */
    closeModal() {
        this.setState({toggleModal : false});
    }

    /**
     * Render the login form
     * @returns {*}
     */
    render(){
        const {handleSubmit} = this.props;
        const TopSliderSettings = {
            arrows: true,
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            swipe:false,
            autoplay: false,
            responsive: [
                {
                breakpoint: 768,
                settings: {
                    arrows: true,
                }
            },
            
        ]
        };
        if(!this.state.showLoader) {
            return (
                <div>
                <section className="film-page">
                        <div>
                            <div className="film-slider last-slide" style={{backgroundImage:'url(assets/images/eathdeck/film_01.png)'}} >
                                <div className="banner-container">
                                    <div className="banner-success">
                                        <img src="assets/images/eathdeck/Success-eon.png" />
                                    </div>
                                    <h4 className="banner-subtitle">Play the video to get your</h4>
                                    <h2 className="banner-title">Your earthDECK</h2>
                                    <h4 className="banner-subtitle">info-cards chosen by your clicks during the film.</h4>
                                    <div className="banner-btn">
                                        <ul className="text-right">
                                            <li><a href="play-film">PLAY</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                </section>
                <About />
                </div>
            );
        } else {
            return <Loader/>
        }
    }
}

/**
 * Form validations
 * @param values
 * @returns {{}}
 */
function validate(values){
    let errors = {};
    return errors;
}

export default reduxForm({
    validate,
    form: 'Login'
})(
    connect(null, {login})(RegistrationSuccess)
);


// WEBPACK FOOTER //
// ./components/Auth/RegistrationSuccess.js